
































import { Component, Vue } from 'vue-property-decorator'

import Booking from '@/models/booking'

import dayjs, { Dayjs } from '@/dayjs'

import { UtilityGetters } from '../store/modules/utility'

interface BookingTopNavRoute {
  name: string
  caption: string
  hidden?: boolean
}

@Component
export default class BookingTopNav extends Vue {
  folded = true

  get currentDate(): Dayjs {
    return this.$store.getters[UtilityGetters.CurrentDate] || dayjs.utc()
  }

  get booking(): Booking {
    return this.$store.getters.getBooking(this.$route.params.id)
  }

  get reviewRequired(): boolean {
    if (this.booking) {
      const cruiseFinishDate = dayjs
        .utc(this.booking.departAt)
        .add(this.booking.numberOfDays, 'days')

      return this.currentDate.isSameOrAfter(cruiseFinishDate)
    } else {
      return false
    }
  }

  get hasCreditNotes(): boolean {
    if (!this.booking) {
      return true
    }
    return !this.booking.hasCreditNotes
  }

  get navigationRoutes(): BookingTopNavRoute[] {
    return [
      { name: 'dashboard', caption: 'Dashboard' },
      {
        name: 'booking',
        caption: this.isMedExperience ? 'Your Tour' : 'Your Cruise',
      },
      { name: 'booking_messages', caption: 'Messages' },
      { name: 'payments', caption: 'Payments' },
      {
        name: 'credit_notes',
        caption: 'Credit Notes',
        hidden: this.hasCreditNotes,
      },
      { name: 'review', caption: 'Review', hidden: !this.reviewRequired },
    ]
  }

  get displayedNavigationRoutes() {
    return this.navigationRoutes.filter((route) => !route.hidden)
  }

  get activeRouteCaption(): string {
    const activeRoute = this.navigationRoutes.find(
      (route) => route.name === this.$route.name,
    )
    const defaultCaption = this.isMedExperience ? 'Your Tour' : 'Your Cruise'

    return activeRoute ? activeRoute.caption : defaultCaption
  }
}
